import _ from "lodash";
import { IProduktdefinition, ITillatnaKvaliteter } from "./IProduktdefinition";
export class ProduktdefinitionGrunddata {
    pristyp: string;
    diameterUnderBark: boolean;
    volymlangdKategori: string;
    apteringsvillkor: string;
    tillatnaKvaliteter: ITillatnaKvaliteter[];
    manuellaKap: boolean;
    mindiameterSok: boolean;
    kvalitetToleransTopp: number;
    kvalitetToleransRot: number;
    minstaToppdiameter: number;
    maxRotdiameter: number;
    kapfonsterOvreGrans: number;
    kapfonsterNedreGrans: number;

    constructor(model: IProduktdefinition) {
        this.pristyp = model.pristyp;
        this.volymlangdKategori = model.volymlangdKategori;
        this.diameterUnderBark = model.diameterUnderBark;
        this.apteringsvillkor = model.apteringsvillkor;
        this.tillatnaKvaliteter = _.orderBy(model.tillatnaKvaliteter, y => y.kvalitet, "asc");
        this.manuellaKap = model.manuellaKap;
        this.mindiameterSok = model.mindiameterSok;
        this.kvalitetToleransTopp = model.kvalitetToleransTopp;
        this.kvalitetToleransRot = model.kvalitetToleransRot;
        this.minstaToppdiameter = model.minstaToppdiameter;
        this.maxRotdiameter = model.maxRotdiameter;
        this.kapfonsterOvreGrans = model.kapfonsterOvreGrans;
        this.kapfonsterNedreGrans = model.kapfonsterNedreGrans;
    }

    mapToDto(model: IProduktdefinition) {
        model.pristyp = this.pristyp;
        model.volymlangdKategori = this.volymlangdKategori;
        model.apteringsvillkor = this.apteringsvillkor;
        model.tillatnaKvaliteter = this.tillatnaKvaliteter;
        model.manuellaKap = this.manuellaKap;
        model.mindiameterSok = this.mindiameterSok;
        model.kvalitetToleransTopp = this.kvalitetToleransTopp;
        model.kvalitetToleransRot = this.kvalitetToleransRot;
        model.minstaToppdiameter = this.minstaToppdiameter;
        model.maxRotdiameter = this.maxRotdiameter;
        model.kapfonsterOvreGrans = this.kapfonsterOvreGrans;
        model.kapfonsterNedreGrans = this.kapfonsterNedreGrans;
    }
}
